module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71281/img/case-study-zero.png"